"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.areaRelativeRadiusScale = areaRelativeRadiusScale;

// Compute circle radius such that relative values are reflected in relative circle areas
function areaRelativeRadiusScale(minNodeValue, maxNodeValue) {
  var minRadius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  var maxRadius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30;
  return function (value) {
    var radius = minRadius;
    var maxArea = Math.pow(maxRadius, 2) * Math.PI;

    if (value && value > 0) {
      var factor = value / maxNodeValue; // Based on area

      var area = maxArea * factor;
      radius = Math.sqrt(area / Math.PI);
    }

    return radius;
  };
}
//# sourceMappingURL=geometryUtils.js.map